import {ImageSlideProps} from "@/components/blocks/event-rotating-image-block/types";

export function ImageSlide({img, i, index, total,}: ImageSlideProps) {

    return (
        <div
            key={i}
            data-slide-index={i}
            className="relative overflow-hidden aspect-video h-full w-full shrink-0 object-top"
            style={{width: `${100 / total}%`}}
        >
            <img
                src={img.src}
                alt={img.alt ?? ""}
                className="block h-auto w-full object-cover object-top select-none"
                draggable={false}
                loading={i === index ? "eager" : "lazy"}
            />
        </div>
    );
}